export default "__VITE_ASSET__DGngKan2__"